import React from 'react';
import { Container, Row, Col, } from 'react-bootstrap';
import { FaPhoneVolume } from "react-icons/fa6";
import { MdLocationOn, MdOutlineEmail } from "react-icons/md";
import Imgxing from '../../assets/xingImg.png'
import Imglinkidin from '../../assets/Linkdin.png'
import Imgyoutube from '../../assets/youtube.png'
import Imgkaggle from '../../assets/kaggleImg.png'
import Imgfacebook from '../../assets/Facebook.png'
import ImgInstagram from '../../assets/insta logo.jpg'
import { Link } from 'react-router-dom';
import './HfFooter.css'
import imgCaGov from '../../assets/ca-gov.png';
import accessibility from '../../assets/policy/Accessibility-Policy-HFC.pdf';
import { useTranslation } from 'react-i18next';


const HfFooter = () => {
  const { t } = useTranslation();
  return (
    <footer className='hfFooter-wrapper' id='contact-us-section'>
      <Container className='hfFooter-container'>
        <Row className="justify-content-center " style={{ marginLeft: 'auto' }}>
          <Col sm={12} lg={3} >
            <div className='footer-column-div'>
              <b>{t('How to reach us')}</b>
              <ul>
                <li><a href="tel:+55 47 3321 6300" className="footer-link"><FaPhoneVolume /> +55 47 3321 6300</a></li>
                <li><a href="mailto:bbl@hansa-flex.com" className="footer-link"><MdOutlineEmail /> bbl@hansa-flex.com</a></li>
                <li><a href="https://maps.app.goo.gl/BshYURN7US8emDfy8" target='_blank' className="footer-link"><MdLocationOn /> Rodovia BR-470, 2461 - Itoupavazinha, Blumenau - SC, 89066-010, Brazil</a></li>
              </ul>
              <br />
            </div>
          </Col>

          <Col sm={12} lg={3}>
            <div className='footer-column-div'>
              <b>{t("About HANSA-FLEX")}</b>
              <ul>
                <li><Link to="/who-we-are" className="footer-link">{t("Who we are")}</Link></li>
                <li><Link to="/hf-group-mission-statement" className="footer-link">{t("Guidelines")}</Link></li>
                <li><Link to="/certificates" className="footer-link">{t("Certificates")}</Link></li>
                <li><Link to="/careers" className="footer-link">{t("Careers")}</Link></li>
                {/* <li><Link to="/code-of-conduct" className="footer-link">Code of Conduct</Link></li> */}
              </ul>
              <br />
            </div>
          </Col>

          <Col sm={12} lg={3}>
            <div className='footer-column-div'>
              <b>{t("Services")}</b>
              <ul>
                <li><Link to="/mobile-rapid-hydraulic-service" className="footer-link">{t("MHS")}</Link></li>
                <li><Link to="/assembly-and-installation" className="footer-link">{t("Assembly and installation")}</Link></li>
                <li><Link to="/preventative-maintainance" className="footer-link">{t("Preventive maintenance")}</Link></li>
                <li><Link to="/x-code-manager" className="footer-link">{t("X-CODE")}</Link></li>
              </ul>
              <br />
            </div>
          </Col>

          <Col sm={12} lg={3}>
            <div className='footer-column-div'>
              <b>{t('Favorite categories')}</b>
              <ul>
                <li><a href="https://my.hansa-flex.com.br/pt_BR/login" target="_blank" rel="noopener noreferrer" className="footer-link">{t("X-CODE Manager")}</a></li>
                <li><Link to="/hydraulic-hoses" className="footer-link">{t("Hydraulic Hoses")}</Link></li>
                 <li><Link to="/news-events" className="footer-link">{t("News")}</Link></li>               
              </ul>
              <br />
            </div>
          </Col>
        </Row>

        <Row>
          <Col className="d-flex justify-content-center align-items-center">
            <b>{t('Follow us')}</b>
          </Col>
        </Row>


        <Row className="custom-3row ">
          <Col><div className="circle-col"><a href="https://www.linkedin.com/company/hansaflexbr/?originalSubdomain=br" target="_blank" rel="noopener noreferrer"><div><img src={Imglinkidin} alt="" /></div></a></div></Col>
          <Col><div className="circle-col"><a href="https://www.youtube.com/@hansa-flexdobrasil" target="_blank" rel="noopener noreferrer"><div><img src={Imgyoutube} alt="" /></div></a></div></Col>
          <Col><div className="circle-col"><a href="https://www.instagram.com/hansaflexbrasil/" target="_blank" rel="noopener noreferrer"><div><img src={ImgInstagram} alt="" /></div></a></div></Col>
          <Col><div className="circle-col"><a href="https://www.facebook.com/pages/Hansa-Flex%20do%20Brasil%20Ltda/173193119537629/#" target="_blank" rel="noopener noreferrer"><div><img src={Imgfacebook} alt="" /></div></a></div></Col>
        </Row>

        <Row className="line-row">
          <Col className="line-col"></Col>
        </Row>

        <div className='HfFooter-link-div'>
          <a className="hf-footer-link" href="">{t("© Copyright, All rights reserved")}</a>
          <span>  |  </span>
          <Link to="/hansa-flex-brazil-privacy-policy" className="footer-link">{t("Privacy Policy")}</Link><span>  |  </span>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              document.cookie = "HFCookieConsent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
              document.cookie = "HFMeasurementConsent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
              window.location.reload();
            }}
            className="footer-link"          >
            {t('Manage Cookie Preferences')}
          </a>


          {/* <a className="hf-footer-link" href="">{t("")}
            <a className="hf-footer-link" href=""></a></a><span>  |  </span> */}

        </div>



      </Container>
    </footer >

  );
};

export default HfFooter;
